import { PageType } from '@/modules/models';


const prodKey = 'YWhhdmE6c2tfbGl2ZV82NUlNc2t5M21RRHFiQXpreWtpbVFScld2V05hdnRNYmNyY1JLRzcyYmJMTkdORm1JZ1pad2FqdnFNTHo2cHlmT0dPVFJET2ZOVVdSTDZuRGFPekxkZERCTFNJdDZ4YU51VGxpbTlXcnhuRmtydjZjQ2tlYm40aVg3d0hnWXlmV0w3OTE2Y1hldHlzWkZXeFRZbVM5bFB3QWlac1o2U2NFSHNMbFg3NmtMdg==';

export const getSayWhattConfig = (isDev: boolean) => ({
  projectName: 'AHAVA',
  apiKey: prodKey,
  apiUrl: 'https://saywhatt-frj5cmaowa-uk.a.run.app',
  pageType: PageType.EMBEDDED,
  isAlwaysOpenWSConnection: true,

  isEmbedded: true,
  onAddToCartFromChat: () => {
    document.body.dispatchEvent(
      new CustomEvent('drawer:toggle', {
        detail: { drawer: 'cart-drawer' },
      })
    );
    document.dispatchEvent(new Event('cart:updated'));
  },
  theme: {
    global: {
      ':host': {
        height: '100%',
      },
    },
    input: {
      styles: {
        minHeight: '38px',
      },
    },
    container: {
      styles: {
        position: 'static',
        bottom: 0,
        left: 0,
        border: '1px solid #fff',
        background: 'rgba(255, 255, 255, 0.8)',
        backdropFilter: 'blur(10px)',
      },
      desktop: {
        maxHeight: 'calc(100dvh - 240px)',
        animation: 'none',
      },
      mobile: {
        height: '100dvh',
        maxHeight: 'calc(100dvh - 77px)',
      },
    },
    messages: {
      styles: {},
      desktop: {
        '::-webkit-scrollbar': {
          width: '4px',
          height: '4px',
        },

        '::-webkit-scrollbar-track': {
          background: 'none',
        },

        '::-webkit-scrollbar-thumb': {
          background: '#B7925B',
          borderRadius: '4px',
        },
      },
    },
    messageText: {
      ml: {
        color: '#000',
        p: {
          fontSize: '16px',
        },
        '.product': {
          border: '1px solid #fff',
          padding: '10px',
          borderRadius: '8px',
        },
        '.product-button': {
          background: '#B7925B',
          color: '#fff',
        },
        '.product-quantity': {
          margin: 0,

          'button, input': {
            height: '20px',
          },
          input: {
            fontSize: '12px',
          },
        },
        '.product-image': {
          width: '115px',
          height: '115px',
        },
        mobile: {
          '.product-image': {
            width: '90px',
            height: '90px',

            img: {
              width: '100%',
              height: '100%',
            },
          },
        },
      },
      user: {
        color: '#0A2233',
        p: {
          fontSize: '16px',
        },
      },
    },
    bubble: {
      user: {
        background: 'rgb(245, 236, 224)',
        boxShadow: '0px 0px 8px 0px rgba(0, 0, 0, 0.2)',
        maxWidth: 'max(75%, 280px)',
        fontSize: '16px !important',
        marginBottom: '10px',

        mobile: {
          width: '285px',
        },
      },
      ml: {
        fontSize: '16px',
        background: '#fff',
        boxShadow: '0px 0px 8px 0px rgba(0, 0, 0, 0.2)',
        maxWidth: 'max(80%, 300px)',
        marginBottom: '22px',
        mobile: {
          width: '300px',
        },
      },
    },
    poweredBy: {
      styles: {
        color: '#000',
      },
    },
  },
});